module.exports = __webpack_public_path__ + "static/features-02-9114e26c9590714deb346043b5bcb312.jpg";